export default "__VITE_ASSET__vOzdQ$hD__"